<template>
  <el-radio-group
    v-model="_value"
    class="currency-tab-item"
  >
    <el-radio
      v-for="(item,index) in options"
      :key="index"
      :label="item"
    >
      <svg-icon :icon-class="getFlagIconName(item)" />
      <b>{{ item }}</b>
    </el-radio>
  </el-radio-group>
</template>

<script>
export default {
  name: 'CurrencyTabItem',
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }

  },
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
::v-deep.currency-tab-item {
	display: flex;
	flex-wrap: wrap;
	.el-radio {
		width: 112px;
		height: 32px;

		border: 1px solid #dfe3e5;
		border-radius: 16px;
		text-align: center;
		margin-right: 16px;
		margin-bottom: 10px;
	}
	.el-radio__input {
		display: none;
	}
	.el-radio__label {
		width: 100%;
		height: 100%;
		padding-left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.el-radio__input.is-checked + .el-radio__label {
		border: 1px solid #1fa0e8;
		box-shadow: 0 0 18px 0 rgba(31, 160, 232, 0.2);
		border-radius: 16px;
		color: #1fa0e8;
	}
	.el-radio__inner {
		display: none;
	}
	b {
		display: inline-block;
		padding-left: 12px;
	}
	.national-flag {
		width: 20px;
		height: 13px;
	}
}
</style>
